import useSWR from 'swr';
import { fetcher } from '../../services/fetcher';
import { moduleConfig } from './config';

export interface SupplierInvoice {
  id: number;
  supplierId: number;
  invoiceTypeId?: number;
  invoiceCategoryId?: number;
  invoiceDate?: string;
  dueDate?: string;
  invoiceNo?: string;
  description?: string;
  currency?: number;
  amount?: number;
  discount?: number;
  vat?: number;
  totalOrIncome?: number;
  notes?: string;
  createdAt?: string;
  createdById?: number;
  updatedAt?: string;
  updatedById?: number;
  paymentTotal?: number | null;
  supplier?: { id: number; name?: string };
  invoiceType?: { id: number; pit_descr?: string };
  invoiceCategory?: { id: number; pic_descr?: string };
  FileAttachment?: Array<{
    id: number;
    fileName?: string;
    filePath?: string;
    fileType?: string;
    fileSize?: number;
    uploadedAt?: string;
  }>;
}

export interface SupplierInvoicesListResponse {
  records: SupplierInvoice[];
  paidCount: number;
  partialCount: number;
  unpaidCount: number;
  overdueCount: number;
}

export const useSupplierInvoices = (searchParams?: string, filter?: string) => {
  let queryString = '';
  if (searchParams || filter) {
    const params = new URLSearchParams();
    if (searchParams) params.append('searchParams', searchParams);
    if (filter) params.append('filter', filter);
    queryString = `?${params.toString()}`;
  }

  const { data, error, isLoading, mutate } = useSWR<SupplierInvoicesListResponse>(
    `${moduleConfig.module.api.list}${queryString}`,
    fetcher,
    { revalidateOnFocus: true, revalidateOnReconnect: true }
  );

  const invoices = data?.records ?? [];
  return {
    data: invoices,
    clients: invoices,
    isLoading,
    isError: error,
    mutate,
    paidCount: data?.paidCount ?? 0,
    partialCount: data?.partialCount ?? 0,
    unpaidCount: data?.unpaidCount ?? 0,
    overdueCount: data?.overdueCount ?? 0,
  };
};

export const useSupplierInvoice = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<SupplierInvoice>(
    id ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true }
  );

  return {
    data,
    client: data,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useSuppliersForSelect = () => {
  const { data } = useSWR<{ records?: { id: number; name?: string }[] }>('/suppliers', fetcher, { revalidateOnFocus: false });
  const suppliers = data?.records ?? [];
  return {
    options: suppliers.map((s) => ({ value: String(s.id), label: s.name || `Supplier #${s.id}` })),
  };
};
